export * from './validation.service'
export * from './cloner'
export * from './constants'
export * from './file-upload.service'
export * from './geocoder.service'
export * from './impersonator.service'
export * from './ticketquota-handling.service';

import { PriceLevelService } from './pricelevel.service'
import { SortService } from './sort.service'
import { FilterListService } from './filterList.service'
import { OauthHelper } from "./webservice"
import { JwtHelper } from "angular2-jwt"
import { Logger } from './logger.service'
import { LoaderService, LoadProcess } from './loader.service'
import { WindowService } from './window.service'
import { WindowOpenService } from './window-open.service'
import { ErrorHandlerService } from './error-handler.service'
import { RoleService } from "./role.service";

import { HttpClient, EventApi, PriceApi, VenueApi, VenueQuery, PaginationConfig, CategoryApi, FileApi, TicketQuotaApi,
	ShoppingCartTicketGroupDTO, ShoppingCartApi, CustomerApi, Query, OpenItemApi , OpenItemQuery, OrderApi, OrderQuery,
	TicketDesignApi,  MerchantApi, QueryMerchantSearch, SponsorApi, QuerySponsorSearch, QuerySponsorCodeSearch, AccountApi,
	SeatingplanApi, EventCategoryApi, PrinterApi, MerchantEmailConfigApi, ReportingApi,
	AdditionalChargeApi, AccessCodesApi } from "./webservice"

import { TicketQuotaMessageService } from '../components/event-components/ticket-quota-collection/ticket-quota-message-service'
import { ImpersonatorService } from './impersonator.service';
import { TicketAddressService } from '../components/checkout-components/ticket-address/reducer/ticket-address.service'

export {
OauthHelper,
LoaderService,
LoadProcess,
Logger,
JwtHelper,
ErrorHandlerService,
FilterListService,
SortService,
ShoppingCartTicketGroupDTO,
PriceLevelService,
RoleService,
CustomerApi,
Query,
TicketQuotaMessageService,
OrderApi,
OrderQuery,
TicketDesignApi,
VenueQuery,
PaginationConfig,
MerchantApi,
QueryMerchantSearch,
SponsorApi,
QuerySponsorSearch,
QuerySponsorCodeSearch,
AccountApi,
SeatingplanApi,
WindowService,
WindowOpenService,
OpenItemApi,
OpenItemQuery,
EventCategoryApi,
PrinterApi,
MerchantEmailConfigApi,
AdditionalChargeApi,
AccessCodesApi,
TicketAddressService,
}

export const SERVICE_PROVIDER = [
	OauthHelper, Logger, LoaderService, JwtHelper, PriceLevelService,
	EventApi, PriceApi, VenueApi, CategoryApi, FileApi, TicketQuotaApi, HttpClient,
	FilterListService, SortService, RoleService, ErrorHandlerService, ShoppingCartApi, OrderApi,
	CustomerApi, TicketQuotaMessageService, TicketDesignApi, MerchantApi, SponsorApi, AccountApi,
	SeatingplanApi, WindowService, WindowOpenService, OpenItemApi, EventCategoryApi, PrinterApi, MerchantEmailConfigApi, ReportingApi,
	AdditionalChargeApi, AccessCodesApi, ImpersonatorService, TicketAddressService
]



// WEBPACK FOOTER //
// ./src/app/services/index.ts